import { render, staticRenderFns } from "./auctionListComponent.vue?vue&type=template&id=2f5e2b70&scoped=true&"
import script from "./auctionListComponent.vue?vue&type=script&lang=ts&"
export * from "./auctionListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./auctionListComponent.vue?vue&type=style&index=0&id=2f5e2b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e2b70",
  null
  
)

export default component.exports